var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgEnterPriseLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 199,
    viewBox: "0 0 270 199",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.681 77.6718C72.681 77.6718 53.3342 106.971 67.0823 151.162C80.8303 195.354 120.888 206.627 144.642 194.355C168.396 182.084 171.86 166.112 191.059 154.522C210.257 142.932 249.846 143.34 265.092 111.454C280.337 79.5675 248.721 34.8771 212.932 9.13886C177.143 -16.5994 99.3445 13.8421 72.681 77.6718Z",
    fill: "#92E3A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M72.681 77.6718C72.681 77.6718 53.3342 106.971 67.0823 151.162C80.8303 195.354 120.888 206.627 144.642 194.355C168.396 182.084 171.86 166.112 191.059 154.522C210.257 142.932 249.846 143.34 265.092 111.454C280.337 79.5675 248.721 34.8771 212.932 9.13886C177.143 -16.5994 99.3445 13.8421 72.681 77.6718Z",
    fill: "#EBECF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.383 96.4347L113.941 96.5429L115.402 102.538L115.844 102.43L114.383 96.4347Z",
    fill: "#FFE266"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M116.356 104.518L115.914 104.626L116.504 107.046L116.945 106.938L116.356 104.518Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8554 172.879L124.863 146.167L109.008 81.0844L0.000119101 107.796L15.8554 172.879Z",
    fill: "#F4C040"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.1511 129.936L0 107.793L109.008 81.0851L63.1511 129.936Z",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1244 65.046L0 107.798L109.032 81.0898L53.7481 61.7106C51.3987 60.8867 48.8616 60.7632 46.4438 61.3552C44.026 61.9471 41.831 63.2291 40.1244 65.046Z",
    fill: "#F9D84B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4269 84.2333L99.9647 86.0666L100.864 89.7621L63.1517 129.936L11.2124 111.723L9.41797 104.347L84.4269 84.2333Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4258 84.2333L88.3832 91.6769L99.9635 86.0666",
    fill: "#E0E0E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4258 84.2333L86.8136 90.5011L99.9635 86.0666",
    fill: "#F0F0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9721 121.6L124.864 146.172L15.8555 172.889L52.3814 126.164C54.5213 123.423 57.5176 121.483 60.8892 120.655C64.2607 119.828 67.8118 120.16 70.9721 121.6Z",
    fill: "#F9D84B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196.893 57.6495L198.214 48.2766C200.727 46.7291 203.117 44.9899 205.363 43.0742C207.473 41.2917 209.309 39.2054 210.809 36.8832C212.245 34.6573 213.176 32.1426 213.536 29.5164C213.824 27.4463 213.583 25.7682 212.814 24.482C212.045 23.1958 210.779 22.4279 209.014 22.1784C208.343 22.0453 207.652 22.0476 206.982 22.1852C206.311 22.3228 205.675 22.593 205.11 22.9799C204.579 23.3904 204.138 23.9068 203.816 24.4966C203.494 25.0864 203.297 25.7367 203.239 26.4065C203.145 27.0517 203.129 27.7059 203.191 28.355C203.253 28.9645 203.334 29.6316 203.435 30.3467L194.032 31.0474C193.829 30.0511 193.707 29.0399 193.668 28.0238C193.631 27.0374 193.682 26.0496 193.821 25.0723C194.399 20.9386 196.124 17.8207 198.999 15.7186C201.873 13.6166 205.665 12.8983 210.373 13.5638C215.181 14.2453 218.727 16.077 221.011 19.0589C223.295 22.0408 224.093 25.9426 223.404 30.7642C223.018 33.7527 222.042 36.634 220.533 39.2396C218.998 41.8006 217.059 44.0942 214.79 46.0305C212.326 48.1535 209.674 50.0459 206.866 51.684L205.847 58.9165L196.893 57.6495ZM194.367 72.9494L195.75 63.1302L205.607 64.5268L204.229 74.3412L194.367 72.9494Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.207 98.1358C144.207 98.1358 113.49 98.5437 112.533 100.737C111.576 102.93 107.207 129.494 106.935 138.651C106.662 147.808 106.528 153.85 107.48 154.944C108.432 156.038 123.319 164.668 123.319 164.668C123.319 164.668 116.357 189.177 118.534 190.003C120.711 190.828 134.101 194.245 142.7 194.384C151.299 194.523 159.769 194.519 160.453 194.519C161.137 194.519 183.116 195.339 190.763 193.559C198.41 191.778 200.726 191.639 200.726 188.63C200.726 185.621 198.812 181.911 198.678 181.239C198.544 180.567 203.87 128.654 200.864 115.922C197.859 103.189 193.902 98.2558 190.897 97.4351C187.892 96.6144 166.458 97.1616 166.458 97.1616L144.207 98.1358Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160.571 109.174C159.54 109.775 158.475 110.312 157.379 110.782",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.955 98.8173C169.212 102.522 165.849 105.721 162.016 108.272",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M170.134 104.298C170.134 104.298 167.316 108.286 164.832 109.616",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M150.613 148.168L149.809 145.663",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M154.997 161.822L151.441 150.735",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M156.09 162.095L159.641 156.48",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M164.141 158.808L172.745 149.084",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.945 189.134L160.459 194.547",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M136.566 187.565L139.744 188.491",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M144.015 37.248C144.015 37.248 134.373 35.0259 132.531 37.5119C130.688 39.9979 134.359 42.3496 133.837 42.8727C133.315 43.3958 122.104 49.1453 123.013 54.77C123.922 60.3947 131.487 66.1441 131.751 67.7279C132.014 69.3116 123.013 69.8203 121.84 72.172C120.668 74.5236 118.969 85.6386 128.75 89.3004C138.531 92.9622 150.762 86.8144 154.17 86.8144C157.577 86.8144 160.95 93.4853 164.86 93.0918C167.242 92.8185 169.432 91.6508 170.99 89.8235C170.99 89.8235 175.029 95.4482 180.895 93.0918C186.762 90.7354 193.543 82.4999 190.676 80.0187C187.81 77.5375 184.546 76.7504 186.633 74.5284C188.719 72.3063 193.021 66.4225 192.375 61.3209C191.729 56.2193 185.724 55.8306 183.379 54.2612C181.034 52.6919 185.987 50.0763 185.858 45.7618C185.728 41.4473 182.594 34.2437 166.693 29.4444C150.791 24.6452 142.967 26.9584 142.183 31.0138C141.937 32.1236 141.977 33.2776 142.297 34.3679C142.618 35.4582 143.209 36.4492 144.015 37.248Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M145.753 79.1981C145.753 79.1981 142.495 99.5948 142.365 100.247C142.236 100.9 148.108 106.784 156.051 105.738C160.704 105.177 164.981 102.894 168.043 99.3356L165.569 79.0685C165.569 79.0685 158.788 82.3368 154.616 82.2072C150.443 82.0776 145.753 79.1981 145.753 79.1981Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M144.414 90.1403L158.143 87.4767L145.754 79.1981L144.414 90.1403Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M138.511 61.2153C138.511 61.2153 136.214 58.2974 135.161 61.9832C134.108 65.669 138.683 70.1419 138.683 70.1419L138.511 61.2153Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M171.418 61.2153C171.418 61.2153 173.715 58.2974 174.768 61.9832C175.821 65.669 171.246 70.1419 171.246 70.1419L171.418 61.2153Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M145.728 42.7767C145.728 42.7767 139.153 49.1836 138.201 51.1033C137.249 53.023 137.632 74.8979 138.68 77.0192C139.728 79.1404 150.207 87.3423 151.92 88.0094C153.634 88.6765 157.543 89.3484 160.591 87.8174C163.64 86.2865 170.975 78.4541 171.741 76.448C172.507 74.442 171.55 51.4921 171.071 49.3084C170.592 47.1248 159.089 39.2396 154.208 38.8605C149.327 38.4814 145.728 42.7767 145.728 42.7767Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.89 38.8605C150.89 38.8605 160.738 47.8735 167.82 48.219L174.907 48.5646C174.907 48.5646 159.355 46.4865 154.517 35.9186C154.517 35.9186 149.163 31.4265 150.89 38.8605Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M156.395 56.728L157.155 66.3793",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M157.923 68.3806C157.923 68.3806 156.206 70.9625 154.966 70.9625C153.727 70.9625 152.492 69.5228 152.492 69.5228",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M147.535 71.5385C147.535 71.5385 149.727 75.1715 152.588 75.3779C154.579 75.4471 156.569 75.2207 158.493 74.706",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M157.54 55.2019C157.54 55.2019 160.889 52.7159 162.205 51.8424C163.521 50.969 167.828 52.6055 167.828 52.6055C167.828 52.6055 164.588 50.7914 162.875 50.5034C161.162 50.2155 157.635 52.7015 157.348 53.8629C157.061 55.0243 156.214 54.722 157.54 55.2019Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M150.677 55.6578C150.502 55.2416 150.211 54.8846 149.84 54.6293C149.468 54.3741 149.031 54.2313 148.581 54.218C146.963 54.122 139.814 56.0369 141.054 56.0369C142.293 56.0369 147.437 55.941 148.772 55.941C149.42 55.9812 150.069 55.8848 150.677 55.6578Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M167.064 61.1241C165.626 61.4512 164.156 61.6122 162.681 61.6041C160.767 61.5081 159.059 60.9322 159.81 61.7912C160.561 62.6503 162.097 63.4182 164.476 62.9383C166.854 62.4583 167.73 61.9832 167.064 61.1241Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M149.825 61.1241C148.386 61.4512 146.916 61.6122 145.441 61.6041C143.527 61.5081 141.824 60.9322 142.57 61.7912C143.317 62.6503 144.857 63.4182 147.241 62.9383C149.624 62.4583 150.475 61.9832 149.825 61.1241Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M118.113 116.2C118.113 116.2 120.984 100.363 122.286 98.8125C123.588 97.2623 137.8 85.605 138.58 84.8227C139.36 84.0404 144.968 75.5362 145.231 76.5824C145.495 77.6287 144.581 82.2071 142.882 84.6883C141.183 87.1695 138.843 90.1835 138.843 90.1835C138.843 90.1835 147.6 92.4055 148.079 92.9286C148.557 93.4517 151.572 99.9595 151.73 100.771C152.007 102.172 151.605 103.674 150.428 103.78C149.356 103.871 142.346 100.247 142.346 100.247L136.757 101.015C136.757 101.015 132.718 105.983 129.976 106.899C128.746 107.35 127.482 107.7 126.196 107.945L126.33 117.621L118.113 116.2Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M139.266 93.1686C139.266 93.1686 146.879 94.1908 147.343 94.5652C147.807 94.9395 151.75 100.771 151.75 100.771",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M139.789 96.6432C139.789 96.6432 147.345 98.3806 147.924 98.8461C148.503 99.3116 151.451 102.757 151.451 102.757",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M151.582 163.329C151.582 163.329 141.342 161.409 140.935 161.274C140.528 161.14 133.279 158.947 132.322 158.534C131.365 158.121 119.76 156.072 119.215 156.893C118.669 157.713 118.124 162.508 117.985 162.916C117.846 163.324 116.755 165.243 117.028 166.342C117.175 167.34 117.175 168.354 117.028 169.352C117.028 169.352 116.889 175.787 118.526 175.927C120.162 176.066 121.67 169.899 121.67 169.899C121.67 169.899 123.991 171.271 128.766 171.545C133.542 171.818 138.188 169.491 138.188 169.491L150.898 172.524L151.582 163.329Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M116.167 113.407L129.895 115.927L129.383 124.532C129.383 124.532 132.422 125.971 133.346 134.471C134.269 142.97 136.915 162.657 136.255 164.116C135.595 165.575 131.499 171.938 121.981 172.337C112.463 172.735 107.309 163.986 106.385 161.198C105.462 158.409 110.352 140.172 110.616 138.584C110.879 136.995 112.2 126.106 113.391 124.268C114.125 123.132 115.015 122.104 116.033 121.215L116.167 113.407Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M124.711 123.332C125.473 123.428 126.24 123.478 127.008 123.481",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M116.02 121.225C117.809 121.85 119.634 122.37 121.484 122.78",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M191.719 117.731L190.355 153.058C190.355 153.058 188.852 153.197 188.307 153.879C187.944 154.351 187.623 154.856 187.35 155.386C187.35 155.386 173.564 155.933 167.008 157.853C163.245 158.926 159.589 160.346 156.088 162.095L150.077 161.966L148.848 177.846L156.906 178.12C156.906 178.12 160.863 180.447 178.885 182.094C196.906 183.74 205.237 184.148 207.146 181.954C209.056 179.761 209.879 176.339 210.152 174.564C210.424 172.788 213.702 161.826 213.702 145.941C213.702 130.055 198.82 107.067 195.542 101.85C192.264 96.6336 188.843 97.0512 186.532 97.6079",
    fill: "#92E3A9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M191.719 117.731L190.355 153.058C190.355 153.058 188.852 153.197 188.307 153.879C187.944 154.351 187.623 154.856 187.35 155.386C187.35 155.386 173.564 155.933 167.008 157.853C163.245 158.926 159.589 160.346 156.088 162.095L150.077 161.966L148.848 177.846L156.906 178.12C156.906 178.12 160.863 180.447 178.885 182.094C196.906 183.74 205.237 184.148 207.146 181.954C209.056 179.761 209.879 176.339 210.152 174.564C210.424 172.788 213.702 161.826 213.702 145.941C213.702 130.055 198.82 107.067 195.542 101.85C192.264 96.6336 188.843 97.0512 186.532 97.6079",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M198.734 150.62L190.355 153.058L198.275 145.663",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M204.01 149.084L201.363 149.857",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M187.352 155.386C187.352 155.386 196.089 156.072 199.64 157.44",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M200.914 163.189C201.334 163.625 201.73 164.083 202.101 164.562",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M190.902 157.305C193.948 158.158 196.787 159.628 199.243 161.625",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M155.953 163.602L156.092 176.882",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M149.398 173.594H155.131",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M150.766 165.791L153.086 165.656",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnterPriseLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/enterPriseLeft.abed04a2.svg";
export { ForwardRef as ReactComponent };